export const shuffleArray = (array) => {
	for (var i = array.length - 1; i > 0; i--) {
		var j = parseInt(Math.random() * i);
		var tmp = array[i];
		array[i] = array[j];
		array[j] = tmp;
	}
	// array.splice(1, 0, "0");
};

export const copyArray = (array) => {
	var copy = [];
	for (var i = 0; i < array.length; i++) {
		copy.push(array[i]);
	}
	return copy;
};

export const getQuery = (name, url) => {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return "";
	return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const colors = [
	"#ff0000",
	"#0000ff",
	"#008000",
	"#800080",
	"#ff7f50",
	"#4682b4",
	"#20b2aa",
	"#2e8b57",
	"#ffa500",
	"#daa520",
	"#228b22",
	"#191970",
	"#da70d6",
	"#98fb98",
	"#008080",
	"#1e90ff",
	"#ffd700",
	"#4682b4",
	"#20b2aa",
	"#2e8b57",
	"#ffa500",
	"#daa520",
	"#228b22",
	"#191970",
	"#da70d6",
	"#98fb98",
	"#008080",
	"#1e90ff",
	"#ffd700",
	"#808080",
];

export const configToken = (state) => {
	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json",
		},
	};

	// Get Token from state
	const token = state.auth.token;

	// if token, add to headers config
	if (token) {
		config.headers["Authorization"] = "Bearer " + token;
	}

	config.headers["Minigame"] = state.auth.game;
	config.headers["Device"] = state.auth.device;

	return config;
};

window.requestAnimFrame = (function () {
	return (
		window.requestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		window.oRequestAnimationFrame ||
		window.msRequestAnimationFrame ||
		function (/* function */ callback, /* DOMElement */ element) {
			window.setTimeout(callback, 1000 / 60);
		}
	);
})();

export function moneyFormatter(num) {
	let formatter = Intl.NumberFormat("id", { notation: "compact" });
	return formatter.format(num);
}

String.prototype.toCapitalize = function () {
	return this.charAt(0).toUpperCase() + this.slice(1);
};
